import { Product, ProjectConstructorConfig, Themes } from '../types';
import { validateEnum, validateProps } from './validateProps';

type componentConstructorArgs = {
  element: HTMLElement;
  /** deprecated */
  theme?: Themes;
};

interface DovetailComponent {
  render: <T>(props: T) => Promise<void>;
  unmount: () => Promise<void>;
}

const componentFactory = (
  getComponentModule: () => Promise<unknown>,
  config: ProjectConstructorConfig
) =>
  function ({
    element,
    theme = config.theme || Themes.default,
  }: componentConstructorArgs): DovetailComponent {
    if (!element) {
      throw new Error(`Cannot inject because provided element was not found.`);
    }

    validateProps(
      { product: config.product, theme },
      { product: 'string', theme: 'string' }
    );
    validateEnum(
      { product: config.product, theme },
      { product: Product, theme: Themes }
    );

    let componentInstanceArgs = { ...config, element, theme };

    type DynamicComponent = {
      default: <T>(componentProps: T) => void;
    };

    return {
      render: async function <T>(props: T): Promise<void> {
        const { default: component }: DynamicComponent =
          (await getComponentModule()) as DynamicComponent;

        componentInstanceArgs = {
          ...componentInstanceArgs,
          ...props,
        };

        element.style.overflow = 'hidden';

        return component(componentInstanceArgs);
      },
      unmount: async (): Promise<void> => {
        const { unmountRoot } = await import('@dovetail/core/utilities');
        unmountRoot(element);
      },
    };
  };

export default componentFactory;
